import { Injectable }              from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Globals }                 from "projects/shared/models/Globals";

@Injectable()
export class ChildWorldService {

    constructor(private httpClient: HttpClient) { }

    getGamesLevels(input) {
        return this.httpClient.post(`${Globals.BaseUrl}/ChildWorld/GetLevelsLookups`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getGamesListingItems(input) {
        return this.httpClient.post(`${Globals.BaseUrl}/ChildWorld/GetGamesListingItems`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }
}